import type { Sugerencia } from '../api';

/** Mínimo de min(monto, total) / max(monto, total) para mostrar una sugerencia del algoritmo. */
export const RATIO_MINIMO_SUGERENCIA = 0.5;

export function sugerenciasComparables(
  montoMovimiento: number,
  monedaMovimiento: string | null | undefined,
  sugerencias: Sugerencia[],
): Sugerencia[] {
  return sugerencias.filter(s => {
    const total = s.cfdi.total;
    if (total == null) return true;
    const monedaCfdi = s.cfdi.moneda;
    if (monedaMovimiento && monedaCfdi && monedaMovimiento.toUpperCase() !== monedaCfdi.toUpperCase()) return true;
    const a = Math.abs(montoMovimiento);
    const b = Math.abs(total);
    const max = Math.max(a, b);
    return max === 0 || Math.min(a, b) / max >= RATIO_MINIMO_SUGERENCIA;
  });
}
